import { bind } from "@react-rxjs/core"
import { distinctUntilChanged, map, scan, switchMap } from "rxjs/operators"

import { tradingGatewayServices$ } from "@/services/tradingGateway"

import { withConnection } from "../withConnection"
import { CurrencyPair } from "./types"

export const [useCurrencyPairs, currencyPairs$] = bind(
  tradingGatewayServices$.pipe(
    switchMap((services) => services.referenceDataService.getCcyPairs()),
    withConnection(),
    scan(
      (acc, data) => {
        const { updates } = data
        const result = { ...acc }
        updates.forEach(({ type, payload }) => {
          const { symbol } = payload
          if (type === "removed") {
            delete result[symbol]
          } else {
            result[symbol] = {
              ...payload,
              base: symbol.substring(0, 3), // TODO: talk with hydra team about this
              terms: symbol.substring(3),
              defaultNotional: symbol === "NZDUSD" ? 10_000_000 : 1_000_000, // TODO: talk with hydra team about this
            }
          }
        })
        return result
      },
      {} as Record<string, CurrencyPair>,
    ),
  ),
)

export const [useCurrencyPair, getCurrencyPair$] = bind((symbol: string) =>
  currencyPairs$.pipe(
    map((currencyPairs) => currencyPairs[symbol]),
    distinctUntilChanged(),
  ),
)

export const currencyPairSymbols$ = currencyPairs$.pipe(
  map((ccyPairs) => Object.keys(ccyPairs)),
)
